import { useContext } from "react";
import { SocketContext } from "./SocketContext";

export const useSocket = () => {
  const state = useContext(SocketContext);
  if (!state) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return state;
};
